import React from 'react';

interface SidebarTooltipProps {
  label: string;
  position: { top: number; left: number };
}

export const SidebarTooltip: React.FC<SidebarTooltipProps> = ({ label, position }) => {
  if (!label) return null;

  return (
    <div
      className="fixed z-50 pointer-events-none"
      style={{
        top: position.top,
        left: position.left,
        transform: 'translateY(-50%)',
      }}
    >
      <div className="px-2.5 py-1.5 text-xs font-medium text-white bg-neutral-900 rounded-md shadow-lg whitespace-nowrap">
        {label}
      </div>
    </div>
  );
};
